<template>
    <SearchBar :placeholder="$t('modules.evaluations.topbar.searchLabel')" :hasResults="hasResults" @queryChange="setQuery">

        <!-- <div class="search_eval_item" v-for="evaluation in searchedEvals" >
            <router-link :to='"/evaluations/" + evaluation.id'>

                <div class="search_eval_item_name">

                    <completedMark :evaluation="evaluation" />
                    <span class="eval_candidate_name">{{evaluation.candidate_username}}</span>

                </div>

            </router-link>
        </div> -->

    </SearchBar>
</template>

<script>
export default {
    name: 'TopbarSearchEval',
    components: {},
    data(){
        return {
            query: ""
        }
    },
    computed: {
        searchedEvals(){
            return this.$store.getters['EvalStore/searchEvals'](this.query)
        },
        hasResults(){
            return this.searchedEvals.length > 0
        }
    },
    methods: {
        setQuery(query){
            this.query = query
            const data = {
                search_query: query,
                page: 1
            }
            this.$store.dispatch('EvalStore/indexEvals', data)
        }
    }
}
</script>


<style lang="scss">
.search_eval_item{
    border-top: 1px solid #ebebeb;
    display: flex;
    a{
        padding: 18px 30px;
        display: block;
    }
    &:first-child{
        border-top: none;
    }
    .search_eval_item_name{
        display: flex;
        align-items: center;
        .completed_mark{
            margin-right: 8px;
        }

    }
}
</style>